import { CONSTANT } from 'data/constant';

export const isTestNet = () => {
	return window.location.origin.includes(CONSTANT.testNet);
};
